export const iconFontAwesomeTextformattingTextSlash = (
	<i className="fa-solid fa-text-slash"></i>
);
